















import { hayawazaLangStorageKey } from "@/common/language";
import { ReloadManager } from "@/common/util/reloadManager";
import System from "@/model/system";
import { vuexStorageKey } from "@/store";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const systemStore = namespace("SystemStore");

@Component({
  name: "Accounting",
})
export default class Accounting extends Vue {
  @systemStore.Getter
  getSystem!: System;

  mounted() {
    ReloadManager.load(this.getSystem).stop();
    localStorage.removeItem(vuexStorageKey);
    localStorage.removeItem(hayawazaLangStorageKey);
  }
}
